export function SuperMajorityIcon(props: Readonly<React.SVGProps<SVGSVGElement>>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.66667 13.3333H1.33333V12C1.33333 10.8954 2.22876 10 3.33333 10C3.9704 10 4.53791 10.2979 4.90416 10.7619M4.66667 13.3333V12C4.66667 11.5625 4.75095 11.1447 4.90416 10.7619M4.66667 13.3333H6.33333M4.90416 10.7619C5.39567 9.53402 6.59654 8.66667 8 8.66667C9.40346 8.66667 10.6043 9.53402 11.0958 10.7619M10 4.66667C10 5.77124 9.10457 6.66667 8 6.66667C6.89543 6.66667 6 5.77124 6 4.66667C6 3.5621 6.89543 2.66667 8 2.66667C9.10457 2.66667 10 3.5621 10 4.66667ZM14 6.66667C14 7.40305 13.403 8 12.6667 8C11.9303 8 11.3333 7.40305 11.3333 6.66667C11.3333 5.93029 11.9303 5.33333 12.6667 5.33333C13.403 5.33333 14 5.93029 14 6.66667ZM4.66667 6.66667C4.66667 7.40305 4.06971 8 3.33333 8C2.59695 8 2 7.40305 2 6.66667C2 5.93029 2.59695 5.33333 3.33333 5.33333C4.06971 5.33333 4.66667 5.93029 4.66667 6.66667Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 12.8L9.90476 14.6667L14.6667 10'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
